import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";

import Home from "@/pages/Home";
import Diensten from "@/pages/Diensten";
import DienstDetail from "@/pages/DienstDetail";
import SectorDetail from "@/pages/SectorDetail";
import Methode from "@/pages/Methode";
import VoorWie from "@/pages/VoorWie";
import WieZijnWij from "@/pages/WieZijnWij";
import DigitaleRegie from "@/pages/DigitaleRegie";
import Over from "@/pages/Over";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import AlgemeneVoorwaarden from "@/pages/AlgemeneVoorwaarden";
import Inzichten from "@/pages/Inzichten";
import ArticleAlgoritmeregister from "@/pages/inzichten/Algoritmeregister";
import ArticleDigitaleAfhankelijkheid from "@/pages/inzichten/DigitaleAfhankelijkheid";
import ArticleDatalek from "@/pages/inzichten/Datalek";
import ArticleAiActReadiness2026 from "@/pages/inzichten/AiActReadiness2026";
import NotFound from "@/pages/NotFound";

export default function App() {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <BrowserRouter>
        <ScrollToTop />
        <Navigation />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/diensten" element={<Diensten />} />
            <Route path="/diensten/:slug" element={<DienstDetail />} />
            <Route path="/sectoren/:slug" element={<SectorDetail />} />
            <Route path="/sectoren" element={<Navigate to="/voor-wie" replace />} />
            <Route path="/methode" element={<Methode />} />
            <Route path="/digitale-regie" element={<DigitaleRegie />} />
            <Route path="/voor-wie" element={<VoorWie />} />
            <Route path="/over-soveu" element={<WieZijnWij />} />
            <Route path="/wie-zijn-wij" element={<Navigate to="/over-soveu" replace />} />
            <Route path="/over" element={<Over />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacybeleid" element={<Privacy />} />
            <Route path="/algemene-voorwaarden" element={<AlgemeneVoorwaarden />} />
            <Route path="/inzichten" element={<Inzichten />} />
            <Route path="/inzichten/algoritmeregister-verplicht-gemeenten" element={<ArticleAlgoritmeregister />} />
            <Route path="/inzichten/digitale-afhankelijkheid-overheid-cloud-act" element={<ArticleDigitaleAfhankelijkheid />} />
            <Route path="/inzichten/datalek-gemeente-onderwijs-avg-data-risicos" element={<ArticleDatalek />} />
            <Route path="/inzichten/ai-act-readiness-2026-mkb-adviesbureaus" element={<ArticleAiActReadiness2026 />} />
            {/* legacy slug → redirect to definitive slug */}
            <Route path="/inzichten/ai-act-mkb-organisaties-2026" element={<Navigate to="/inzichten/ai-act-readiness-2026-mkb-adviesbureaus" replace />} />
            {/* legacy redirect */}
            <Route path="/voorwaarden" element={<Navigate to="/algemene-voorwaarden" replace />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}
